/** Auto-reload for self-serve OMS, only applied when the team has none of its own. */
export const OMS_TRIAL_AUTO_RELOAD = {
  thresholdUsd: 50,
  amountUsd: 200,
} as const;
